import { useState } from 'react'
import { DEFAULT_TEMPLATE_CATEGORY_VALUE } from '@/lib/templates/template-category-selection'
import type { TemplatesFavoritedFilter } from '../../templates-panel/templates-panel'

/**
 * Same idea as `useClikArtFilters`, for Templates' category selection and applied filters
 * (keyword ids, name search, favorited) — WMPCM-11026 AC-8. Sort and "Show filename" are not
 * lifted, matching ClikArt's own scoping.
 *
 * Returns the controlled props for `TemplatesPanel`.
 */
export function useTemplatesFilters() {
  const [categoryValue, setCategoryValue] = useState(DEFAULT_TEMPLATE_CATEGORY_VALUE)
  const [selectedKeywordIds, setSelectedKeywordIds] = useState<string[]>([])
  const [nameQuery, setNameQuery] = useState('')
  const [favoritedFilter, setFavoritedFilter] = useState<TemplatesFavoritedFilter>('any')

  return {
    categoryValue,
    onCategoryValueChange: setCategoryValue,
    selectedKeywordIds,
    onSelectedKeywordIdsChange: setSelectedKeywordIds,
    nameQuery,
    onNameQueryChange: setNameQuery,
    favoritedFilter,
    onFavoritedFilterChange: setFavoritedFilter,
  }
}
